import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import type { Pokemon } from './types'

// Define a service using a base URL and expected endpoints
export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery(
    {
      // baseUrl: 'https://localhost:44315/api/',
      // PRODUCTION DEPLOYMENT
      baseUrl: 'https://dahaccapi20231003.azurewebsites.net/api/',
      // LOWER ENV
      // baseUrl: 'https://daccwebapi.azurewebsites.net/api/',
      prepareHeaders: (headers) => {
        const token = sessionStorage.getItem("token");

        // If we have a token set in state, let's assume that we should be passing it.
        if (token) {
          headers.set('authorization', `Bearer ${token}`)
        }

        return headers
      },
    }
  ),
  endpoints: (builder) => ({
    // validateUserAndGetDetails: builder.query({
    //   query: (email) => `userlogin?userEmail=${email}`,
    // }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {  } = userApi